import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
const POSTS = [{
  title: 'Why we built Giga to run in Slack',
  excerpt: 'Context switching is the enemy of deep work. Here is why we decided to bring the AI directly to where your team already communicates.',
  category: 'Product',
  date: 'Jun 12, 2026',
  readTime: '4 min read',
  image: 'https://images.unsplash.com/photo-1618044733300-9472054094ee?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'The end of the weekly status update',
  excerpt: 'How AI coworkers are replacing manual reporting rituals with real-time, perfectly synthesized updates.',
  category: 'Future of Work',
  date: 'May 28, 2026',
  readTime: '6 min read',
  image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Introducing Always-On Triggers',
  excerpt: 'Wire Giga to your webhooks and CRM events to automate workflows even when your laptop is closed.',
  category: 'Announcements',
  date: 'May 15, 2026',
  readTime: '3 min read',
  image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'How to write better prompts for your AI coworker',
  excerpt: 'Stop treating AI like a search engine. Learn how to delegate tasks effectively with context and constraints.',
  category: 'Guides',
  date: 'Apr 22, 2026',
  readTime: '8 min read',
  image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'Security first: Our journey to SOC 2 Type 2',
  excerpt: 'A transparent look at how we architected Giga to keep enterprise data safe and isolated from the start.',
  category: 'Engineering',
  date: 'Apr 05, 2026',
  readTime: '5 min read',
  image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'The ROI of an AI coworker',
  excerpt: 'Breaking down the math on how saving 4 hours a week per employee compounds across a 100-person team.',
  category: 'Business',
  date: 'Mar 18, 2026',
  readTime: '6 min read',
  image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=800'
}];
export function Blog() {
  return <div className="min-h-screen bg-[#FAF8F4] pt-32 pb-24" data-id="element-7247" data-mp="1dhrpoqy0fmuf">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10" data-id="element-7248" data-mp="1dg6qup4nxhqr">
        {/* Header */}
        <div className="max-w-2xl mb-16 md:mb-24" data-id="element-7249" data-mp="psyp2h6g0qth">
          <motion.span initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-sm font-bold tracking-widest uppercase text-[#EA580C] mb-4 block" data-id="element-7250" data-mp="ku453bwqow7s">
            Blog
          </motion.span>
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-6xl font-title font-bold text-[#2B211A] mb-6 tracking-tight leading-[1.1]" data-id="element-7251" data-mp="upyuqqzdrrk2">
            Thoughts on the future of work.
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="text-lg md:text-xl text-neutral-600 leading-relaxed" data-id="element-7252" data-mp="2ihy9vuogx8ys">
            Product updates, guides, and essays on how AI is changing the way
            teams operate.
          </motion.p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10" data-id="element-7253" data-mp="31fio87tlwp55">
          {POSTS.map((post, i) => <motion.article key={post.title} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1 * i + 0.3
        }} className="group flex flex-col cursor-pointer" data-id="element-7254" data-mp="2nfzu4ixmrebu" data-mpi={i}>
              <div className="relative w-full aspect-[16/10] rounded-2xl overflow-hidden mb-6 bg-neutral-200" data-id="element-7255" data-mp="1h18iplavsb3k">
                <img src={post.image} alt={post.title} className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500" data-id="element-7256" data-mp="1wbf0sztok28v" />
                <div className="absolute inset-0 ring-1 ring-inset ring-black/10 rounded-2xl pointer-events-none" data-id="element-7257" data-mp="1mjj2bnnoma44" />
              </div>

              <div className="flex items-center gap-3 text-xs font-medium text-neutral-500 mb-3" data-id="element-7258" data-mp="1ik0iywbie73e">
                <span className="text-[#EA580C] bg-[#EA580C]/10 px-2.5 py-1 rounded-full" data-id="element-7259" data-mp="2f86hr2lr259r">
                  {post.category}
                </span>
                <span data-id="element-7260" data-mp="267rsjs5o060z">{post.date}</span>
                <span data-id="element-7261" data-mp="266p1nk8ce3l2">·</span>
                <span data-id="element-7262" data-mp="26a4ioslktmp4">{post.readTime}</span>
              </div>

              <h2 className="text-xl md:text-2xl font-title font-bold text-[#2B211A] mb-3 group-hover:text-[#EA580C] transition-colors leading-snug" data-id="element-7263" data-mp="2185fpjtr0rsp">
                {post.title}
              </h2>

              <p className="text-neutral-600 text-sm md:text-base leading-relaxed mb-5 flex-1" data-id="element-7264" data-mp="psyxkdh83fbf">
                {post.excerpt}
              </p>

              <div className="flex items-center gap-2 text-sm font-bold text-[#2B211A] group-hover:text-[#EA580C] transition-colors mt-auto" data-id="element-7265" data-mp="31fajuc89k8bw">
                Read article{' '}
                <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" data-id="element-7266" data-mp="3agiiiveozb6i" />
              </div>
            </motion.article>)}
        </div>
      </div>
    </div>;
}